import { render } from "./ButtonRegister.vue?vue&type=template&id=31444011&scoped=true"
import script from "./ButtonRegister.vue?vue&type=script&lang=js"
export * from "./ButtonRegister.vue?vue&type=script&lang=js"

import "./ButtonRegister.vue?vue&type=style&index=0&id=31444011&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\wwwda\\OneDrive\\Desktop\\проекты-и-учебные-файлы-front\\pizzares\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31444011"]])

export default __exports__